import { Address } from 'viem'

export const ZERO_ADDRESS: Address = '0x0000000000000000000000000000000000000000'
export const ZERO_BYTES_32: Address = '0x0000000000000000000000000000000000000000000000000000000000000000'